// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__xegjN","subheader":"ReorderModal_subheader__yofbL","listWrap":"ReorderModal_listWrap__3Ej2v"};